import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { StoreProvider } from '@/context/StoreContext';
import './styles.css';
import './payment-checkout.css';
import './master-polish-v721.css';
import './moissanite-luxury-v1.css';
import './mielley-brand-v12-1.css';
import './mielley-header-v12-1-2.css';
import './mielley-header-repair-v12-1-3.css';
import './mielley-header-wordmark-v12-1-4.css';
import './mielley-header-lower-wordmark-v12-1-4-1.css';
import './mielley-v12-1-6-storefront-admin-fix.css';
import './mielley-about-v12-1-7.css';
import './mielley-contact-v12-1-8.css';
import './mielley-announcement-ticker-v1.css';
import { AccessibilityWidget } from '@/components/accessibility/AccessibilityWidget';
import { PasswordRecoveryGate } from '@/components/auth/PasswordRecoveryGate';
import { MielleyAnalyticsTracker } from '@/components/analytics/MielleyAnalyticsTracker';
import '@/admin/MielleyAdminMockupMatchV2.css';
import '@/product-card-hover-v1-1.css';
import '@/product-card-hover-v1-2.css';
import '@/product-card-hover-v1-3.css';
import '@/mielley-home-cards-v1-4.css';
import '@/mielley-home-edit-header-v1.css';
import '@/mielley-home-edit-header-v1-1.css';

createRoot(document.getElementById('root')!).render(<StrictMode><StoreProvider><><PasswordRecoveryGate><App/></PasswordRecoveryGate><MielleyAnalyticsTracker/><AccessibilityWidget/></></StoreProvider></StrictMode>);

